// $(function(){
//   $('a[href^="#"]').on("click", function() {
//     var speed = 600;
//     var header_height = $("header").height();
//     var href= $(this).attr("href");
//     var target = $(href == "#" || href == "" ? 'html' : href);
//     var position = target.offset().top - header_height;
//     $('body,html').animate({scrollTop:position}, speed, 'swing');
//     return false;
//   });
// });

// 配達希望日を選択時、最後の商品に”_shippingHopeDate”としてpropertyを付加する
// mode: 0 => 設定
// mode: 1 => クリア
function addShippingHopeDateToItem(v, mode) {

  let week = ["日", "月", "火", "水", "木", "金", "土"];
  v = NGCformatDate(new Date(v), "YYYY/MM/DD") + "(" + week[(new Date(v)).getDay()] + ")";

  // console.log(v);

  $.ajax({
    type: 'GET',
    url: '/cart.json',
    cache: false,
    dataType: 'json',
    contentType: 'json',
  }).done(function( data ) {
    console.log(data);

    if(mode == 0){
      // セット

      var properties = data.items[0].properties;
      if(properties == null || properties == undefined){
        properties = {};
      }
      properties['_shippingHopeDate'] = v;

      var changeDate = {
        line: 1,
        properties: properties,
      };

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: 'json',
        contentType: 'json',
        data: JSON.stringify(changeDate),
        headers: {
          'Content-Type': 'application/json'
        },
      }).done(function( data ) {
        console.log(data);

      }).fail(function(XMLHttpRequest, textStatus, errorThrown){
        console.log(errorThrown);
      });


    }else if(mode == 1){
      // クリア
      for(var i=0; i<data.items.length; i++){
        const item = data.items[i];

        if (item.properties && item.properties.hasOwnProperty('_shippingHopeDate')) {
          // キーが存在する場合の処理

        } else {
          //キーが存在しない場合の処理
          continue;
        }

        var properties = item.properties;
        delete properties['_shippingHopeDate'];

        var changeDate = {
          line: (i+1),
          properties: properties,
        };

        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: 'json',
          contentType: 'json',
          data: JSON.stringify(changeDate),
          headers: {
            'Content-Type': 'application/json'
          },
        }).done(function( data ) {
          console.log(data);

        }).fail(function(XMLHttpRequest, textStatus, errorThrown){
          console.log(errorThrown);
        });

      }

    }


  })
  .fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
  });

}


var shippingAfter = 3;
var shippingArea = 'other';

function getShippingAfterOnCart() {

  $.ajax({
    type: "GET",
    url: "/cart.json",
    dataType: 'json',
    contentType: 'json',
  }).done(function( data ) {
    // console.log(data);

    for(var i=0; i<data.items.length; i++){
      var item = data.items[i];
      var tmpAfter = 3;

      if(item.sku.includes('530')){
        // 肉類
        tmpAfter = 8;
      }else if(item.title.includes('わかさいも')){
        // わかさいも
        tmpAfter = 5;
      }else if(item.sku.includes('531') || item.sku.includes('532') || item.sku.includes('533') || item.sku.includes('534')){
        // 酒類
        if(item.sku == '531-07') {
          // おたる生ワイン3本セット
          if(item.quantity >= 5){
            tmpAfter = 5;
          }
        }else if(item.sku == '531-08' || item.sku == '531-09') {
          // 道民還元（赤）、道民還元（白）
          if(item.quantity >= 5){
            tmpAfter = 7;
          }
        }else if(item.sku == '532-01' || item.sku == '532-02' || item.sku == '532-03' || item.sku == '532-04' || item.sku == '532-06' || item.sku == '532-07' || item.sku == '532-08' || item.sku == '532-09' || item.sku == '532-10' || item.sku == '532-11') {
          //
          if(item.quantity >= 24){
            tmpAfter = 5;
          }
        }else if(item.sku == '532-05' || item.sku == '532-12') {
          //
          if(item.quantity >= 5){
            tmpAfter = 5;
          }
        }else if(item.sku == '532-17') {
          // 喜多里 ミニチュア瓶4本セット
          if(item.quantity >= 5){
            tmpAfter = 5;
          }
        }else if(item.sku == '533-01' || item.sku == '533-08' || item.sku == '534-05') {
          // 男山 純米大吟醸 雪美月 北海道限定、純米吟醸 大雪（雪中貯蔵） 北海道限定、純米大吟醸 北の錦
          if(item.quantity >= 5){
            tmpAfter = 7;
          }
        }else if(item.sku == '534-09') {
          // 千歳鶴 地酒飲み比べ 300ml×3本
          if(item.quantity >= 5){
            tmpAfter = 5;
          }
        }else if(item.sku == '534-10') {
          // 高砂酒造 北海道地酒造 300ml×3本
          if(item.quantity >= 5){
            tmpAfter = 7;
          }
        }else{
          // その他
          if(item.quantity >= 5){
            tmpAfter = 5;
          }
        }
      }

      if(tmpAfter > shippingAfter){
        shippingAfter = tmpAfter;
      }
    }

    console.log(shippingAfter);

  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
  });

}


function reloadCartModal(openModal) {

  $('#headerCartLoading').fadeIn(200);

  $.ajax({
    type: "GET",
    url: "/cart.json",
    dataType: 'json',
    contentType: 'json',
  }).done(function( data ) {
    // console.log(data);

    var itemCount = data.items.length;
    $('#headerCartNum').html(itemCount);
    if(itemCount > 0){
      $('#headerCartNum').fadeIn(200);
      $('#headerCartBtnGoCart').fadeIn(200);
      $('#headerCartBtnGoCheckout').fadeIn(200);
    }else{
      $('#headerCartNum').fadeOut(200);
      $('#headerCartBtnGoCart').fadeOut(200);
      $('#headerCartBtnGoCheckout').fadeOut(200);
    }

    var sumPrice = 0;

    var html = ``;
    data.items.reverse().forEach(function(e){
      var rowPrice = (e.price/100) * e.quantity;
      sumPrice += rowPrice;

      html += `
        <div class="header__cart__products__item">
          <div class="header__cart__products__pic-area">
            <div class="header__cart__products__pic"><img class="header__cart__products__img" src="`+ e.image +`" alt="" loading="lazy"></div>
            <button class="header__cart__products__btn" onclick="deleteCartItem('`+ e.key +`');">削除</button>
          </div>
          <div class="header__cart__products__txt">
            <p class="header__cart__products__brand">`+ e.vendor +`</p><a class="header__cart__products__name" href="`+ e.url +`">`+ e.title.replace('　', '<br>') +`</a>
            <p class="header__cart__products__price">`+ Number(e.price/100).toLocaleString() +`円</p>
            <p class="header__cart__products__num">数量：`+ e.quantity +`</p>
            <p class="header__cart__products__total">`+ Number(rowPrice).toLocaleString() +`円</p>
          </div>
        </div>
      `;
    });
    if(html == '') {
      html = `<p class="header__cart__empty">カートは空です</p>`;
    }

    $('#headerCartProducts').html(html);

    $('#headerCartSumPrice').html(Number(sumPrice).toLocaleString());

    var noticePrice = 5400 - sumPrice;
    if(noticePrice <= 0){
      $('#headerCartNotice').hide();
    }else{
      $('#headerCartNoticePrice').html(Number(noticePrice).toLocaleString());
      $('#headerCartNotice').show();
    }

    $('#headerCartLoading').fadeOut(200);

    if(openModal){
      if(!$(".js-cart-btn").hasClass('is-show')){
        $(".js-cart-cont").addClass('is-show');
      }
    }

  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
    $('#headerCartLoading').fadeOut(200);
  });

}


function deleteCartItem(id) {

  $('#headerCartLoading').fadeIn(200);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: 'json',
    contentType: 'json',
    data: JSON.stringify({id: id, quantity: 0}),
    headers: {
      'Content-Type': 'application/json'
    },
  }).done(function( data ) {
    // console.log(data);

    reloadCartModal(false);

  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
  });

}


function addCartItem(product_form_id) {

  var formSel = 'form#'+product_form_id+' ';

  $('#addCartBtnGuard').fadeIn(150);

  var id = Number($(formSel+'input[name="id"]').val());
  var quantity = Number($(formSel+'input[name="quantity"]').val());

  var properties = {};
  if($(formSel+'input[name="properties[_shippingType]"]').length > 0){
    properties['_shippingType'] = $(formSel+'input[name="properties[_shippingType]"]').val();
  }
  if($(formSel+'select[name="properties[のし]"]').length > 0){
    properties['のし'] = $(formSel+'select[name="properties[のし]"]').val();
  }
  if($(formSel+'textarea[name="properties[のし下]"]').length > 0){
    properties['のし下'] = $(formSel+'textarea[name="properties[のし下]"]').val();
  }
  if($(formSel+'input[name="properties[包装]"]').length > 0){
    properties['包装'] = $(formSel+'input[name="properties[包装]"]').val();
  }

  var postData = {
    items: [
      {
        id: id,
        quantity: quantity,
        properties: properties
      }
    ]
  };

  // console.log(postData);
  // console.log(JSON.stringify(postData));

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: 'json',
    contentType: 'json',
    data: JSON.stringify(postData),
    headers: {
      'Content-Type': 'application/json'
    },
  }).done(function( data ) {
    // console.log(data);

    $('#addCartBtnGuard').fadeOut(150);

    $('#addCartBtnMsg').fadeIn(300);
    setTimeout(function() {
      $('#addCartBtnMsg').fadeOut(300);
    }, 3000);

    reloadCartModal(true);


  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
    $('#addCartBtnGuard').fadeOut(150);
  });

}


$(function(){

  if(document.location.pathname.match(/cart/)) {
    getShippingAfterOnCart();
  }else{
    reloadCartModal(false);
  }

  // ページ読み込み時、のし・包装のオプションをリセット
  $('.m-card__noshi__select').val('のし不要');
  $('.m-card__wrapping__check').removeAttr('checked').prop('checked', false).change();
  $('#noshiSel').val('のし不要');
  $('#wrappingCheck').removeAttr('checked').prop('checked', false).change();

});



//--------------------------------------
// 商品カードからのカート操作
//--------------------------------------
function onChangeNoshiFromCard(e, id, section_id) {
  // console.log(e);
  // console.log(id);

  if(e == 'のし不要'){
    $('form#product-card-form-'+id+'-'+section_id+' .noshiShita').html('');
  }else{
    if($('form#product-card-form-'+id+'-'+section_id+' .card__noshi__textarea').length == 0){
      var html = `
        <div class="m-card__noshi__lower js-noshi-input-area">
          <p class="m-card__noshi__title">のし下</p>
          <textarea class="m-card__noshi__textarea" name="properties[のし下]" placeholder="1行あたり10文字程度//のし下は基本的にお名前（会社名、役職）が入ります。※ふりがなをご希望の場合はお名前の後ろに（）をつけてご記入ください。"></textarea>
          <p class="m-card__noshi__desc">47文字入力できます。</p>
          <p class="m-card__noshi__cap">※改行すると「＿」という文字に置き換わります。<br>※英語表記は縦書きになります。</p>
        </div>
      `;
      $('form#product-card-form-'+id+'-'+section_id+' .noshiShita').html(html);
    }
  }

}

function onChangeWrappingFromCard(e, id, section_id) {
  // console.log(e);
  // console.log(id);

  if (e) {
    $('form#product-card-form-'+id+'-'+section_id+' .wrappingHiddenArea').html('<input type="hidden" name="properties[包装]" value="希望する">');
  } else {
    $('form#product-card-form-'+id+'-'+section_id+' .wrappingHiddenArea').html('');
  }
}

function addCartItemFromCard(id, section_id) {

  var formSel = 'form#product-card-form-'+id+'-'+section_id+' ';
  var cardSel = 'div#product-card-'+id+'-'+section_id+' ';

  $(cardSel+'.addCartBtnGuard').fadeIn(150);


  var quantity = Number($(formSel+'input[name="quantity"]').val());

  var properties = {};
  if($(formSel+'input[name="properties[_shippingType]"]').length > 0){
    properties['_shippingType'] = $(formSel+'input[name="properties[_shippingType]"]').val();
  }
  if($(formSel+'select[name="properties[のし]"]').length > 0){
    properties['のし'] = $(formSel+'select[name="properties[のし]"]').val();
  }
  if($(formSel+'textarea[name="properties[のし下]"]').length > 0){
    properties['のし下'] = $(formSel+'textarea[name="properties[のし下]"]').val();
  }
  if($(formSel+'input[name="properties[包装]"]').length > 0){
    properties['包装'] = $(formSel+'input[name="properties[包装]"]').val();
  }

  var postData = {
    items: [
      {
        id: Number(id),
        quantity: quantity,
        properties: properties
      }
    ]
  };

  // console.log(postData);
  // console.log(JSON.stringify(postData));

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: 'json',
    contentType: 'json',
    data: JSON.stringify(postData),
    headers: {
      'Content-Type': 'application/json'
    },
  }).done(function( data ) {
    // console.log(data);

    $(cardSel+'.addCartBtnGuard').fadeOut(150);

    $('#addCartBtnMsg').fadeIn(300);
    setTimeout(function() {
      $('#addCartBtnMsg').fadeOut(300);
    }, 3000);

    reloadCartModal(true);


  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
    $(cardSel+'.addCartBtnGuard').fadeOut(150);
  });

}


//--------------------------------------
// 検索
//--------------------------------------

function searchExe() {

  var keyword = $('#inputSearchKeyword').val();

  if(keyword == ''){

    $('#searchResultArea').fadeOut(200);
    $('#searchCatMenu').fadeIn(200);

  }else{

    $('#searchResult').html('');
    $('#searchKeyword').html(keyword);
    $('#searchLoading').show();
    $('#searchCatMenu').fadeOut(200);
    $('#searchResultArea').fadeIn(200);

    fetch('/search?type=product&q='+keyword)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        var dom = new DOMParser().parseFromString(html, 'text/html');

        $('#searchLoading').hide();
        $('#searchResult').html(dom.getElementById('searchResultHTML').innerHTML);

        if($('#searchResult').html() == ''){
          $('#searchResult').html('<p class="searchEmpty">該当する商品がありません。</p>');
        }

        spinner();

        const $tab = $(".js-search-modal-tab");
        $tab.each(function (index) {
          if($(this).hasClass('is-cur')) {
            if (index === 0) {
      				$('#searchResult .m-card.meika').show();
      				$('#searchResult .m-card.other').show();
      			}else if(index == 1){
      				$('#searchResult .m-card.meika').show();
      				$('#searchResult .m-card.other').hide();
      			}else if(index == 2) {
      				$('#searchResult .m-card.meika').hide();
      				$('#searchResult .m-card.other').show();
      			}
          }
        });

      });

  }


}
